import React from 'react';
import { useTranslation } from 'react-i18next';
import { Cpu, Shield, Gauge } from 'lucide-react';
import { PricingCard } from '../components/PricingCard';
import { DatacenterShowcase } from '../components/DatacenterShowcase';
import { ServerLocationSelector } from '../components/ServerLocationSelector';

export function DedicatedPage() {
  const { t } = useTranslation();
  const location = 'falkenstein';

  const dedicatedLinks = {
    i9: 'https://my.synthohosting.net/store/dedicated/i9',
    ryzen5: 'https://my.synthohosting.net/store/dedicated/ryzen5',
    i5: 'https://my.synthohosting.net/store/dedicated/i5',
    ryzen9pro: 'https://my.synthohosting.net/store/dedicated/ryzen9pro',
    ryzen9enterprise: 'https://my.synthohosting.net/store/dedicated/ryzen9enterprise'
  };

  return (
    <div className="pt-16">

      {/* HERO */}
      <div className="relative bg-gradient-to-br from-blue-900 to-blue-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold mb-6">
            {t('dedicated.title')}
          </h1>
          <p className="text-xl text-blue-100 max-w-3xl">
            {t('dedicated.subtitle')}
          </p>
        </div>
      </div>

      {/* CONTENUTO */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="bg-white p-6 rounded-xl shadow-lg">
            <Cpu className="w-12 h-12 text-blue-600 mb-4" />
            <h3 className="text-xl font-bold mb-2">
              {t('dedicated.features.hardware.title')}
            </h3>
            <p className="text-gray-600">
              {t('dedicated.features.hardware.description')}
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-lg">
            <Shield className="w-12 h-12 text-blue-600 mb-4" />
            <h3 className="text-xl font-bold mb-2">
              {t('dedicated.features.security.title')}
            </h3>
            <p className="text-gray-600">
              {t('dedicated.features.security.description')}
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-lg">
            <Gauge className="w-12 h-12 text-blue-600 mb-4" />
            <h3 className="text-xl font-bold mb-2">
              {t('dedicated.features.performance.title')}
            </h3>
            <p className="text-gray-600">
              {t('dedicated.features.performance.description')}
            </p>
          </div>
        </div>

        <h2 className="text-3xl font-bold mb-8">
          {t('dedicated.plans.title')}
        </h2>

        <ServerLocationSelector
          selectedLocation={location}
          onLocationChange={() => {}}
        />

        <div className="mb-16 space-y-12">

          {/* Riga superiore: 3 server */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {t('dedicated.plans.falkenstein.servers', { returnObjects: true })
              .slice(0, 3)
              .map((server: any, index: number) => (
                <PricingCard
                  key={index}
                  title={server.title}
                  price={server.price}
                  specs={server.specs}
                  buyLink={Object.values(dedicatedLinks)[index]}
                />
              ))}
          </div>

          {/* Riga inferiore: 2 server */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {t('dedicated.plans.falkenstein.servers', { returnObjects: true })
              .slice(3, 5)
              .map((server: any, index: number) => (
                <PricingCard
                  key={index + 3}
                  title={server.title}
                  price={server.price}
                  specs={server.specs}
                  buyLink={Object.values(dedicatedLinks)[index + 3]}
                />
              ))}
          </div>

        </div>
      </div>

      <DatacenterShowcase />
    </div>
  );
}
